import React from 'react';
import { motion } from 'framer-motion';
import { Anchor, ShieldAlert } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-6 md:pt-20 md:pb-16 overflow-hidden bg-navy-950" data-id="element-68">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-luminosity" data-id="element-69"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950/80 via-navy-950/95 to-navy-900" data-id="element-70"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl" data-id="element-71">
        <div className="text-center mb-6 md:mb-8" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 bg-gold-500/10 border border-gold-500/30 text-gold-400 px-4 py-2 rounded-full text-xs md:text-sm font-bold tracking-wider uppercase mb-4 md:mb-6" data-id="element-73">
            <Anchor className="w-4 h-4" data-id="element-74" />
            CHARTER COMMAND SYSTEM™
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-tight mb-4 md:mb-6" data-id="element-75">
            El sistema definitivo para capitanes que quieren{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-76">
              control total
            </span>
            , tripulación alineada y clientes satisfechos.
          </motion.h1>
        </div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="relative max-w-md mx-auto mb-6 md:mb-10 cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/o84EoTBPw5ywUQWWSku2EC/IMAGEN_PRINCIPAL.png" alt="Charter Command System™ — El Sistema Definitivo para Capitanes de Charter" className="w-full h-auto rounded-2xl shadow-[0_0_60px_rgba(212,168,67,0.2)] hover:shadow-[0_0_80px_rgba(212,168,67,0.3)] transition-shadow duration-500" data-id="element-78" />
        </motion.div>

        <div className="max-w-3xl mx-auto text-base md:text-xl text-slate-300 space-y-3 md:space-y-4 text-center" data-id="element-79">
          <p className="flex items-center justify-center gap-2 text-red-400 font-bold text-lg md:text-xl" data-id="element-80">
            <ShieldAlert className="w-5 h-5 md:w-6 md:h-6" data-id="element-81" />
            Si sentís que todo depende de vos… seguí leyendo.
          </p>
          <p data-id="element-82">Porque ese es exactamente el problema.</p>
          <p data-id="element-83">
            Y no… no es tu experiencia. No es tu tripulación. No es el barco.
          </p>
          <p className="text-xl md:text-2xl font-bold text-white py-2" data-id="element-84">
            👉 Es que estás operando sin un sistema.
          </p>
        </div>
      </div>
    </section>;
}